import React from "react";
import { Text, View, StyleSheet } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function NotificationIcon(props) {
  return (
    <View style={styles.container}>
      <Svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M11.37 6.12L9.22498 3.975C5.62498 6.72 3.25498 10.95 3.04498 15.75H6.04498C6.15124 13.8477 6.68522 11.9939 7.60719 10.3266C8.52915 8.65926 9.81533 7.22138 11.37 6.12V6.12ZM29.955 15.75H32.955C32.73 10.95 30.36 6.72 26.775 3.975L24.645 6.12C26.193 7.2268 27.4734 8.66627 28.3923 10.3327C29.3112 11.9991 29.8451 13.8502 29.955 15.75ZM27 16.5C27 11.895 24.54 8.04 20.25 7.02V6C20.25 4.755 19.245 3.75 18 3.75C16.755 3.75 15.75 4.755 15.75 6V7.02C11.445 8.04 8.99998 11.88 8.99998 16.5V24L5.99998 27V28.5H30V27L27 24V16.5ZM18 33C18.21 33 18.405 32.985 18.6 32.94C19.575 32.73 20.37 32.07 20.76 31.17C20.91 30.81 20.985 30.42 20.985 30H14.985C15 31.65 16.335 33 18 33Z"
          fill="#48A9C2"
        />
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },
});
